import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ConversationThreadServant } from '../../../src/servants/conversation_thread_servant';
import { Conversation } from '../../builders/conversation_builder';
import { ConversationThreadsQuery } from '../../queries/conversation_threads_query';
import { ConversationsQuery } from '../../queries/conversations_query';

export class ConversationThreadsContentController {
  private isLoading: boolean = true;
  private isIntermediateThreadsOpen: boolean = false;

  constructor(
    private $stateParams: ng.ui.IStateParamsService,
    private loadConversationThreadsCommand: ICommand,
    private updateConversationStatusCommand: ICommand,
    private ngConversationThreadServant: ConversationThreadServant,
    private ngConversationThreadsQuery: ConversationThreadsQuery,
    private ngConversationsQuery: ConversationsQuery,
    private ConversationThreadStatusEnum: any
  ) {}

  $onInit() {
    this.loadConversationThreadsCommand(this.$stateParams.id).then(() => {
      this.isLoading = false;
      const unReadIDs = this.ngConversationThreadServant.unreadThreadIDs;
      if (!_4.isEmpty(unReadIDs)) {
        this.updateConversationStatusCommand(
          this.ngConversationThreadServant.unreadThreadIDs,
          this.ConversationThreadStatusEnum.READ.value
        );
        const conv = _4.findLast(
          this.ngConversationsQuery.result.conversations,
          (con) => con.id === this.$stateParams.id
        );
        _4.set(conv, 'unread', 0);
      }
    });
  }

  toggleIntermediateThreads(): void {
    this.isIntermediateThreadsOpen = !this.isIntermediateThreadsOpen;
  }
}

export class ConversationThreadsContentComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-conversations/src/components/conversation_threads_content/conversation_threads_content.html';
  public controller: any = ConversationThreadsContentController;
  public controllerAs: string = '$ctrl';
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-conversations/src/components/conversation_threads_content/conversation_threads_content_controller.ts